<template>
    <div class="about">
        about
        about
        about
    </div>
</template>
<script setup lang="ts">
</script>
